import { render, staticRenderFns } from "./AddRemoveButton.vue?vue&type=template&id=2fbde41e&"
import script from "./AddRemoveButton.vue?vue&type=script&lang=js&"
export * from "./AddRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports